module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-C"
  }, [_c('div', {
    staticClass: "headBar"
  }, [(_vm.querys.pressType == 1) ? _c('span', [_vm._v("音像制品出版单位审核")]) : (_vm.querys.pressType == 2) ? _c('span', [_vm._v("电子出版物出版单位审核 ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.querys.pressName))])]), _vm._v(" "), (_vm.wSat == 1) ? _c('CommonTab', {
    ref: "mainTab",
    attrs: {
      "cancelFlag": false,
      "pressType": _vm.querys.pressType,
      "pressDat": _vm.resDat,
      "role": "show",
      "organization": _vm.querys.pressName,
      "defaultYear": _vm.querys.year1
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.querys.pressType == 1) ? _c('div', {
    staticClass: "progressTab",
    staticStyle: {
      "margin-left": "30px",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("以下情况数字会进行标红")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 1、领导班子成员持证上岗率：")]), _c('span', [_vm._v("上岗率低于50%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 2、出版物数量：")]), _vm._v("\n      2023 + 2024年出版物数量小于10\n\n      "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 3、编辑人员人数：")]), _vm._v("\n      取得国家出版专业技术人员资格的编辑人员，其人数小于10人\n\n      "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 4、出版专业中级职称以上人数：")]), _vm._v("\n      具有中级以上出版专业职业资格人数小于5人\n\n      ")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressType == 2) ? _c('div', {
    staticClass: "progressTab",
    staticStyle: {
      "margin-left": "30px",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("以下情况数字会进行标红")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 1、领导班子成员持证上岗率：")]), _c('span', [_vm._v("上岗率低于50%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 2、出版专业中级职称以上人数：")]), _vm._v("\n      具有中级以上出版专业职业资格人数小于2人\n\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "informationStatic",
    staticStyle: {
      "padding": "10px 50px 50px 50px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("第一年度出版物数量")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.firstYearDeliverNum + _vm.publishUnitJson.secondYearDeliverNum < 10 ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.firstYearDeliverNum))])]), _vm._v(" "), _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("第二年度出版物数量")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.firstYearDeliverNum + _vm.publishUnitJson.secondYearDeliverNum < 10 ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.secondYearDeliverNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("领导班子成员持证上岗率（%）")]), _vm._v(" "), _c('span', {
    class: _vm.publishUnitJson.workerProportion < 50 ? 'highlight' : ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.workerProportion))])]), _vm._v(" "), (_vm.querys.pressType == 1) ? _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("取得国家出版专业技术人员资格的编辑人员数")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.zjCertificate < 10 ? 'highlight' : ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.zjCertificate))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("出版专业中级职称以上人数")]), _vm._v(" "), _c('span', {
    class: (_vm.querys.pressType == 1 && _vm.publishUnitJson.zjCertificateWorkers < 5) ||
      (_vm.querys.pressType == 2 && _vm.publishUnitJson.zjCertificateWorkers < 2) ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.zjCertificateWorkers))])])])]), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "250",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "min-width": "300",
      "label": "审核意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l(((scope.row.examineMessage || '').split('；')), function(item, index) {
          return _c('div', {
            key: index,
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._v("\n              " + _vm._s(item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "") + "\n            ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "150",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "radioBx",
    staticStyle: {
      "padding": "10px 30px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '21'
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '13'
    }
  }, [_vm._v("注销或拟注销")])], 1), _vm._v(" "), (
    _vm.params.status == '1' ||
    _vm.params.status == '3' ||
    _vm.params.status == '21' ||
    _vm.params.status == '12' ||
    _vm.params.status == '13'
  ) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写意见"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.goBackExamsave
    }
  }, [_vm._v("退回")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("提交审核意见")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版单位信息统计")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("流转记录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar",
    staticStyle: {
      "height": "auto",
      "line-height": "20px",
      "margin-bottom": "10px",
      "padding-bottom": "10px",
      "margin-top": "10px",
      "padding-top": "10px"
    }
  }, [_c('span', [_vm._v("审核    \n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar",
    staticStyle: {
      "height": "auto",
      "line-height": "20px",
      "margin-bottom": "10px",
      "padding-bottom": "10px",
      "background-color": "#fff"
    }
  }, [_c('span', [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("1.因出版单位在系统填写中存在问题，需退回出版单位修正的，按“退回”键。")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("2.审核意见提交（3选1）"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ① 通过"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ② 暂缓登记（暂不具备年检通过条件，但仍继续办社的，选此项。缓登后整改应提交整改报告。）"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ③ 注销或拟注销（暂不具备办社基本条件且已经主办单位同意进行注销的，选此项）"), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c9e4436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provinceRole/Audio_Elect/commonTabs.vue
// module id = 1769
// module chunks = 1